/* 🤖 this file was generated by svg-to-ts */
export const matIconMenu: {
  name: 'menu';
  data: string;
} = {
  name: 'menu',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>`
};
